import React from 'react'
import { Table } from '../../components'
import { checkNegative, STRING } from '../../helpers'
import NumberFormat from 'react-number-format'

export class FinancialRatioTable extends React.Component {
  render() {
    const { info } = this.props
    return info && info.length ? (
      <Table className="theme-green financial-ratio financial-score">
        <Table.THEAD>
          <Table.TR className="header">
            <Table.TH className="number">{STRING.NO}</Table.TH>

            <Table.TH className="ratio">{STRING.RATIO}</Table.TH>

            <Table.TH
              className={`year-detail ${checkNegative(info[0].FISCAL_YEAR)}`}
            >
              {info[0].FISCAL_YEAR - 543}
            </Table.TH>

            <Table.TH
              className={`year-detail ${checkNegative(info[1].FISCAL_YEAR)}`}
            >
              {info[1].FISCAL_YEAR - 543}
            </Table.TH>

            <Table.TH
              className={`year-detail ${checkNegative(info[2].FISCAL_YEAR)}`}
            >
              {info[2].FISCAL_YEAR - 543}
            </Table.TH>
          </Table.TR>
        </Table.THEAD>

        {/* group with TBODY */}
        <Table.TBODY>
          <Table.TR className="sub-header">
            <Table.TD className="detail-list" colSpan="5">
              {STRING.PROFITABILITY_RATIO}
            </Table.TD>
          </Table.TR>
          {/* data content below [mockup data] */}
          <Table.TR>
            <Table.TD className="number">1</Table.TD>
            <Table.TD className="ratio">{STRING.RETURN_ON_ASSET} (%)</Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].RETURN_ON_ASSET
              )}`}
            >
              {info[0].RETURN_ON_ASSET == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].RETURN_ON_ASSET}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].RETURN_ON_ASSET
              )}`}
            >
              {info[1].RETURN_ON_ASSET == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].RETURN_ON_ASSET}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].RETURN_ON_ASSET
              )}`}
            >
              {info[2].RETURN_ON_ASSET == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].RETURN_ON_ASSET}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="number">2</Table.TD>
            <Table.TD className="ratio">{STRING.RETURN_ON_EQUITY} (%)</Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].RETURN_ON_EQUITY
              )}`}
            >
              {info[0].RETURN_ON_EQUITY == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].RETURN_ON_EQUITY}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].RETURN_ON_EQUITY
              )}`}
            >
              {info[1].RETURN_ON_EQUITY == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].RETURN_ON_EQUITY}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].RETURN_ON_EQUITY
              )}`}
            >
              {info[2].RETURN_ON_EQUITY == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].RETURN_ON_EQUITY}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="number">3</Table.TD>
            <Table.TD className="ratio">
              {STRING.GROSS_PROFIT_MARGIN} (%)
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].GROSS_PROFIT_MARGIN
              )}`}
            >
              {info[0].GROSS_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].GROSS_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].GROSS_PROFIT_MARGIN
              )}`}
            >
              {info[1].GROSS_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].GROSS_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].GROSS_PROFIT_MARGIN
              )}`}
            >
              {info[2].GROSS_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].GROSS_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="number">4</Table.TD>
            <Table.TD className="ratio">
              {STRING.OPERATING_PROFIT_MARGIN} (%)
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].OPERATING_PROFIT_MARGIN
              )}`}
            >
              {info[0].OPERATING_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].OPERATING_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].OPERATING_PROFIT_MARGIN
              )}`}
            >
              {info[1].OPERATING_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].OPERATING_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].OPERATING_PROFIT_MARGIN
              )}`}
            >
              {info[2].OPERATING_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].OPERATING_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="number">5</Table.TD>
            <Table.TD className="ratio">
              {STRING.NET_PROFIT_MARGIN} (%)
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].NET_PROFIT_MARGIN
              )}`}
            >
              {info[0].NET_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].NET_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].NET_PROFIT_MARGIN
              )}`}
            >
              {info[1].NET_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].NET_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].NET_PROFIT_MARGIN
              )}`}
            >
              {info[2].NET_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].NET_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>
        </Table.TBODY>

        {/* group with TBODY */}
        <Table.TBODY>
          <Table.TR className="sub-header">
            <Table.TD className="detail-list" colSpan="5">
              {STRING.OPERATING_EFFICIENCY_RATIO}
            </Table.TD>
          </Table.TR>
          {/* data content below [mockup data] */}
          <Table.TR>
            <Table.TD className="number">6</Table.TD>
            <Table.TD className="ratio">{STRING.CURRENT_RATIO}</Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[0].CURRENT_RATIO)}`}
            >
              {info[0].CURRENT_RATIO == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].CURRENT_RATIO}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[1].CURRENT_RATIO)}`}
            >
              {info[1].CURRENT_RATIO == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].CURRENT_RATIO}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[2].CURRENT_RATIO)}`}
            >
              {info[2].CURRENT_RATIO == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].CURRENT_RATIO}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="number">7</Table.TD>
            <Table.TD className="ratio">
              {STRING.ACCOUNTS_RECEIVABLE_TURNOVER}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].ACCOUNT_RECEIVABLE_TURNOVER
              )}`}
            >
              {info[0].ACCOUNT_RECEIVABLE_TURNOVER == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].ACCOUNT_RECEIVABLE_TURNOVER}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].ACCOUNT_RECEIVABLE_TURNOVER
              )}`}
            >
              {info[1].ACCOUNT_RECEIVABLE_TURNOVER == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].ACCOUNT_RECEIVABLE_TURNOVER}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].ACCOUNT_RECEIVABLE_TURNOVER
              )}`}
            >
              {info[2].ACCOUNT_RECEIVABLE_TURNOVER == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].ACCOUNT_RECEIVABLE_TURNOVER}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="number">8</Table.TD>
            <Table.TD className="ratio">{STRING.INVENTORY_TURNOVER}</Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].INVENTORY_TURNOVER
              )}`}
            >
              {info[0].INVENTORY_TURNOVER == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].INVENTORY_TURNOVER}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].INVENTORY_TURNOVER
              )}`}
            >
              {info[1].INVENTORY_TURNOVER == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].INVENTORY_TURNOVER}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].INVENTORY_TURNOVER
              )}`}
            >
              {info[2].INVENTORY_TURNOVER == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].INVENTORY_TURNOVER}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>
        </Table.TBODY>

        {/* group with TBODY */}
        <Table.TBODY>
          <Table.TR className="sub-header">
            <Table.TD className="detail-list" colSpan="5">
              {STRING.LIQUIDITY_RATIO}
            </Table.TD>
          </Table.TR>
          <Table.TR>
            <Table.TD className="number">9</Table.TD>
            <Table.TD className="ratio">
              {STRING.TOTAL_ASSETS_TURNOVER}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].TOTAL_ASSET_TURNOVER
              )}`}
            >
              {info[0].TOTAL_ASSET_TURNOVER == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].TOTAL_ASSET_TURNOVER}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].TOTAL_ASSET_TURNOVER
              )}`}
            >
              {info[1].TOTAL_ASSET_TURNOVER == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].TOTAL_ASSET_TURNOVER}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].TOTAL_ASSET_TURNOVER
              )}`}
            >
              {info[2].TOTAL_ASSET_TURNOVER == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].TOTAL_ASSET_TURNOVER}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>
        </Table.TBODY>

        {/* group with TBODY */}
        <Table.TBODY>
          <Table.TR className="sub-header">
            <Table.TD className="detail-list" colSpan="5">
              {STRING.FINANCIAL_POSITION_RATIO}
            </Table.TD>
          </Table.TR>
          <Table.TR>
            <Table.TD className="number">10</Table.TD>
            <Table.TD className="ratio">
              {STRING.OPERATING_EXPENSE_RATIO} (%)
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[0].COST_TO_INCOME)}`}
            >
              {info[0].COST_TO_INCOME == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].COST_TO_INCOME}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[1].COST_TO_INCOME)}`}
            >
              {info[1].COST_TO_INCOME == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].COST_TO_INCOME}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[2].COST_TO_INCOME)}`}
            >
              {info[2].COST_TO_INCOME == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].COST_TO_INCOME}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="number">11</Table.TD>
            <Table.TD className="ratio">
              {STRING.ASSET_TO_EQUITY_RATIO}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].TOTAL_ASSET_TO_EQUITY
              )}`}
            >
              {info[0].TOTAL_ASSET_TO_EQUITY == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].TOTAL_ASSET_TO_EQUITY}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].TOTAL_ASSET_TO_EQUITY
              )}`}
            >
              {info[1].TOTAL_ASSET_TO_EQUITY == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].TOTAL_ASSET_TO_EQUITY}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].TOTAL_ASSET_TO_EQUITY
              )}`}
            >
              {info[2].TOTAL_ASSET_TO_EQUITY == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].TOTAL_ASSET_TO_EQUITY}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="number">12</Table.TD>
            <Table.TD className="ratio">{STRING.DEBT_ASSET}</Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[0].DEBT_ASSET)}`}
            >
              {info[0].DEBT_ASSET == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].DEBT_ASSET}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[1].DEBT_ASSET)}`}
            >
              {info[1].DEBT_ASSET == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].DEBT_ASSET}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[2].DEBT_ASSET)}`}
            >
              {info[2].DEBT_ASSET == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].DEBT_ASSET}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>
          <Table.TR>
            <Table.TD className="number">13</Table.TD>
            <Table.TD className="ratio">
              {STRING.DEBIT_TO_EQUITY_RATIO}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[0].DEBT_TO_EQUITY)}`}
            >
              {info[0].DEBT_TO_EQUITY == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].DEBT_TO_EQUITY}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[1].DEBT_TO_EQUITY)}`}
            >
              {info[1].DEBT_TO_EQUITY == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].DEBT_TO_EQUITY}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
            <Table.TD
              className={`year-detail ${checkNegative(info[2].DEBT_TO_EQUITY)}`}
            >
              {info[2].DEBT_TO_EQUITY == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].DEBT_TO_EQUITY}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>
          </Table.TR>
        </Table.TBODY>
      </Table>
    ) : null
  }
}
